<template>
  <div v-if="order" class="rm-go-sheet">
    <div class="rm-go-sheet__top">
      <span class="rm-go-badge rm-go-badge--static" :style="badgeStyle(currentState)">
        <i class="rm-go__dot" :style="dotStyle(currentState)"></i>
        {{ $t(currentState) }}
      </span>
      <span class="rm-muted rm-num">{{ formatDateTime(order.created_at) }}</span>
    </div>

    <div class="rm-go-steps" role="group" :aria-label="$t('status')">
      <button
        v-for="item in orderStatuses"
        :key="item.value"
        type="button"
        class="rm-go-step"
        :aria-pressed="String(currentState === item.value)"
        :disabled="busy"
        :style="stepStyle(item.value)"
        @click="handleStatusClick(item.value)"
      >
        <v-icon size="16">{{ item.icon }}</v-icon>
        {{ $t(item.value) }}
      </button>
    </div>

    <section class="rm-card rm-go-sheet__card">
      <div class="rm-go-sheet__who">
        <b>{{ guestName }}</b>
        <span v-if="guest && guest.email" class="rm-muted">{{ guest.email }}</span>
      </div>
      <a v-if="guest && guest.phone" class="rm-btn rm-btn--sm" :href="`tel:${guest.phone}`">
        <v-icon size="18" color="#1c1917">mdi-phone</v-icon>
        {{ guest.phone }}
      </a>
    </section>

    <section class="rm-card rm-go-sheet__card rm-go-sheet__card--col">
      <span class="rm-go-sheet__label">
        <v-icon size="14">{{ deliveryType.icon }}</v-icon>
        {{ deliveryType.label }}
      </span>
      <template v-if="order.delivery_type === 0">
        <b v-if="order.location">{{ order.location.address }}</b>
        <span v-if="order.location" class="rm-muted">
          {{ order.location.city ? order.location.city.name : "" }}
          <template v-if="order.location.apartment"> · {{ $t("apartment") }}: {{ order.location.apartment }}</template>
          <template v-if="order.location.floor"> · {{ $t("floor") }}: {{ order.location.floor }}</template>
        </span>
      </template>
      <div class="rm-go-sheet__times">
        <div>
          <span class="rm-go-sheet__label">{{ $t("ordered") }}</span>
          <b class="rm-num">{{ formatDateTime(order.created_at) }}</b>
        </div>
        <div>
          <span class="rm-go-sheet__label">{{ $t("deliver_until") }}</span>
          <b class="rm-num rm-go-sheet__due">
            {{ formatScheduledDate(order.date) }}
            {{ order.delivery_time ? order.delivery_time.substring(0, 5) : "–" }}
          </b>
        </div>
      </div>
    </section>

    <section class="rm-card rm-go-sheet__card rm-go-sheet__card--col">
      <span class="rm-go-sheet__label">
        <v-icon size="14">mdi-food-outline</v-icon>
        {{ $t("ordered") }}
      </span>
      <ul class="rm-list rm-go-sheet__items">
        <li
          v-for="(line, index) in orderLines"
          :key="line.id || index"
          :class="{ 'is-choice': line.line_type === 'choice', 'is-package': line.line_type === 'package' }"
        >
          <b v-if="line.line_type !== 'choice'" class="rm-num rm-go-sheet__qty">{{ line.quantity }}×</b>
          <v-icon v-else size="14" color="#8a817a">mdi-subdirectory-arrow-right</v-icon>
          <span class="rm-go-sheet__item">
            <template v-if="line.line_type === 'choice' && line.quantity > 1">{{ line.quantity }}× </template>
            {{ toLatin(line.food ? line.food.name : line.meals ? line.meals.name : "") }}
          </span>
          <span v-if="line.line_type !== 'choice'" class="rm-num">
            {{ (line.price * line.quantity).toFixed(2) }} {{ orderCurrency }}
          </span>
          <span v-else-if="Number(line.price) > 0" class="rm-muted rm-num">
            +{{ (line.price * line.quantity).toFixed(2) }} {{ orderCurrency }}
          </span>
        </li>
      </ul>
    </section>

    <div class="rm-go-sheet__total">
      <span>{{ $t("total") }}</span>
      <b class="rm-num">{{ calculateOrderTotal.toFixed(2) }} {{ orderCurrency }}</b>
    </div>

    <button type="button" class="rm-btn" @click="printOrder">
      <v-icon size="18" color="#1c1917">mdi-printer-outline</v-icon>
      {{ $t("print") }}
    </button>

    <prep-time-dialog v-model="prepTimeDialog" @select-minutes="confirmPrepMinutes" @ready-now="confirmReadyNow"></prep-time-dialog>
  </div>
</template>

<script>
import GuestOrderPanel from "../GuestOrderPanel.vue";
import { getStatusColors } from "@/utils/guestOrderStatus";

/**
 * Detalji narudžbe u donjoj kartici na telefonu. Ista logika kao panel na računaru (GuestOrderPanel):
 * status jednim dodirom, "Prihvaćeno" pita za vreme pripreme, štampa narudžbe; samo je izgled mobilni.
 */
export default {
  name: "GuestMobileOrderSheet",
  extends: GuestOrderPanel,
  methods: {
    badgeStyle(state) {
      const colors = getStatusColors(state);
      return { backgroundColor: colors.bg, color: colors.fg };
    },
  },
};
</script>
